const authSx = {
  root: {
    backgroundColor: '#363740',
    minHeight: '100dvh',
    overflowY: 'auto',
  },
  input: {
    marginBottom: 2,
  },
  form: {
    backgroundColor: 'common.white',
    border: '1px solid',
    borderColor: 'info.400',
    borderRadius: '8px',
  },
  logoLabel: {
    color: 'rgba(164,166,179,0.7)',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20px',
  },
  createAccount: {
    letterSpacing: '.2px',
    color: 'info.600',
    marginRight: 2,
  },
  googleLoginBtn: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '12px',
    '& img': {
      width: 20,
      height: 20,
      display: 'block',
    },
  },
  appleLoginBtn: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: '8px',
    textAlign: 'center',
    borderRadius: '12px',
    '& .MuiButton-startIcon': {
      margin: '0 !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      lineHeight: 1,
    },
    '& .MuiButton-startIcon > svg': {
      fontSize: '26px',
      display: 'block',
      
    },
  },
};

export default authSx;
